export default __webpack_public_path__ + "static/media/digistore24.5557d56f.png";